import React, { useCallback, useMemo } from 'react';
import { ScreenContainer, ContentFrame, Button } from '@pinwheel/origami';
import { TemplateContinue } from '../components/TemplateContinue';
import CircledX from '../assets/CircledX';
import { useOpts } from '../context';
import { useAppSelector } from '../state';
import { selectError } from '../state/slices/slice-error';
import PendingRetryImage from '../components/PendingRetryImage';
import useTerminalScreenButtonText from '../hooks/useTerminalScreenButtonText';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import { useDDFormContext } from '../hooks/useDDFormContext';
import useLinkNavigate from '../hooks/useLinkNavigate';
export var ErrorImage = function () { return (React.createElement("div", null,
    React.createElement(CircledX, { size: 80, color: "#4D5E73" }))); };
/**
 * This component is used to show the error screen.
 */
var Error = function () {
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var setDDFormEntryPoint = useDDFormContext().setDDFormEntryPoint;
    var _a = useOpts(), linkTokenPayload = _a.linkTokenPayload, featureFlags = _a.featureFlags, exit = _a.exit;
    var error = useAppSelector(selectError);
    var handleExit = useCallback(function () {
        exit();
    }, [exit]);
    var shouldShowDDFormPrompt = useMemo(function () {
        return (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.directDepositForms) &&
            (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.depositForms) !== 'disabled';
    }, [featureFlags, linkTokenPayload]);
    var continueButtonLabel = useTerminalScreenButtonText();
    var title = useMemo(function () {
        return (error === null || error === void 0 ? void 0 : error.pendingRetry)
            ? getLocalizedString('WORKING_ON_REQUEST')
            : (error === null || error === void 0 ? void 0 : error.message)
                ? error.message
                : getLocalizedString('SOMETHING_UNEXPECTED_HAPPENED');
    }, [error, getLocalizedString]);
    var subtitle = useMemo(function () {
        return (error === null || error === void 0 ? void 0 : error.pendingRetry) && (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName)
            ? getLocalizedString('WILL_LET_YOU_KNOW', [linkTokenPayload.orgName])
            : (error === null || error === void 0 ? void 0 : error.message)
                ? shouldShowDDFormPrompt
                    ? getLocalizedString('DD_FORM_PROMPT')
                    : null
                : getLocalizedString('TRYING_TO_FIX');
    }, [
        error,
        getLocalizedString,
        linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName,
        shouldShowDDFormPrompt,
    ]);
    var buttons = useMemo(function () {
        if (shouldShowDDFormPrompt) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Button, { eventId: "Error-continue", dataTestId: "button", onClick: handleExit, "aria-label": continueButtonLabel, variant: "ghost" }, continueButtonLabel),
                React.createElement(Button, { eventId: "DDForm-begin", dataTestId: "button-continue", onClick: function () {
                        setDDFormEntryPoint('dds_error');
                        navigate('/dd-form/primer');
                    } }, getLocalizedString('USE_A_FORM_INSTEAD'))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { eventId: "Error-continue", dataTestId: "button", onClick: handleExit, "aria-label": continueButtonLabel }, continueButtonLabel)));
    }, [
        shouldShowDDFormPrompt,
        continueButtonLabel,
        handleExit,
        getLocalizedString,
        navigate,
        setDDFormEntryPoint,
    ]);
    var Image = useMemo(function () { return ((error === null || error === void 0 ? void 0 : error.pendingRetry) ? PendingRetryImage : ErrorImage); }, [error]);
    return (React.createElement(ScreenContainer, { "data-testid": "ErrorScreen" },
        React.createElement(ContentFrame, null,
            React.createElement(TemplateContinue, { Image: Image, title: title, subtitle: subtitle, actions: buttons, dataTestId: "ErrorFeedback" }))));
};
export default Error;
